import { render, staticRenderFns } from "./ProductCustom.vue?vue&type=template&id=431bf70e"
import script from "./ProductCustom.vue?vue&type=script&lang=js"
export * from "./ProductCustom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports